import { Link, NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';

const NAV = [
  { to: '/services', label: 'Services' },
  { to: '/team', label: 'Team' },
  { to: '/salon', label: 'The Salon' },
  { to: '/products', label: 'Products' },
  { to: '/journal', label: 'Journal' },
  { to: '/booths', label: 'Booth Rental' },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header className={`site-header${scrolled ? ' is-scrolled' : ''}`}>
      <div className="site-header__inner container">
        <Link to="/" className="wordmark" onClick={() => setOpen(false)}>
          <span className="wordmark__name">The Loft</span>
          <span className="wordmark__sub">Salon · Temecula</span>
        </Link>

        <nav className="site-nav" aria-label="Primary">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `site-nav__link${isActive ? ' is-active' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link to="/team" className="btn btn--primary site-nav__cta">
            Find a stylist
          </Link>
        </nav>

        <button
          className="nav-toggle"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span className={`nav-toggle__bars${open ? ' is-open' : ''}`} />
        </button>
      </div>

      <div
        className={`mobile-menu${open ? ' is-open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!open}
      >
        <nav className="mobile-menu__nav" aria-label="Mobile">
          <NavLink to="/" end className="mobile-menu__link" onClick={() => setOpen(false)}>
            Home
          </NavLink>
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className="mobile-menu__link"
              onClick={() => setOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
          <NavLink to="/contact" className="mobile-menu__link" onClick={() => setOpen(false)}>
            Contact
          </NavLink>
          <Link
            to="/team"
            className="btn btn--primary mobile-menu__cta"
            onClick={() => setOpen(false)}
          >
            Find a stylist
          </Link>
        </nav>
        <p className="mobile-menu__meta">
          31217 Pauba Rd, Suite 202 · Temecula
          <br />
          <a href="tel:9516946016">(951) 694-6016</a>
        </p>
      </div>
    </header>
  );
};

export default Header;
